import { BREAKPOINTS } from '../constants'
import { defaultPreset } from './default'

/** Legacy quotes widget slider. Always 1 slide per view with auto height. */
export const quotesPreset = {
  ...defaultPreset,
  speed: 1000,
  slidesPerView: 1,
  slidesPerGroup: 1,
  autoHeight: true,
  observer: true,
  observeParents: true,
  slideToClickedSlide: true,
  navigation: {
    enabled: false,
  },
  breakpoints: {
    [BREAKPOINTS.LG]: {
      navigation: {
        enabled: true,
      },
    },
  },
}
